import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  /**
   * # Truncate Controller.
   *
   * If the element does not have the classes "position-relative" and "text-truncate", they will be set.
   *
   * ## Optional API
   * __values__
   *
   * * data-truncate-expand-text-value - default: mehr
   * * data-truncate-collapse-text-value - default: weniger
   *
   * __classes__
   *
   * classes for the added `a` element to toggle truncation
   * * data-truncate-expand-class - default: "position-absolute end-0 px-2 bg-white bg-opacity-75 fw-bold"
   * * data-truncate-collapse-style-class - default: "ms-1"
   */
  static values = {
    expandText: { type: String, default: "mehr" },
    collapseText: { type: String, default: "weniger" },
  };
  static classes = ["expand", "collapse"];

  get expandCls() {
    if (!this.hasExpandClass) {
      return "position-absolute end-0 px-2 bg-white bg-opacity-75 fw-bold top-0".split(
        " ",
      );
    }
    return this.expandClasses;
  }

  get collapseCls() {
    if (!this.hasCollapseClass) {
      return "ms-3".split(" ");
    }
    return this.collapseClasses;
  }

  truncate(set) {
    if (set) {
      for (const br of this.element.getElementsByTagName("br")) {
        br.style = "display: none;";
        const spacer = document.createElement("span");
        spacer.classList.add("pseudo-br");
        br.insertAdjacentElement("afterend", spacer);
      }
      this.element.classList.add("text-truncate");
    } else {
      for (const br of this.element.getElementsByTagName("br")) {
        br.removeAttribute("style");
      }
      const pseudoBreaks = [
        ...this.element.getElementsByClassName("pseudo-br"),
      ];
      for (const pseudoBr of pseudoBreaks) {
        pseudoBr.remove();
      }
      this.element.classList.remove("text-truncate");
    }
  }

  connect() {
    this.element.classList.add("position-relative"); // needed for toggleLink overlay
    this.truncate(true);
    this.truncates = this.element.offsetWidth < this.element.scrollWidth;
    this.truncate(false); // reset pseduo breaks

    if (this.truncates) {
      this.toggleLink = document.createElement("a");
      this.element.appendChild(this.toggleLink);
      this.collapse();
    }
  }

  collapse() {
    this.truncate(true);
    const iconElement = document.createElement("i");
    iconElement.className = "bi bi-caret-down-fill ps-1";
    this.toggleLink.text = this.expandTextValue;
    this.toggleLink.appendChild(iconElement);
    this.toggleLink.classList.remove(...this.collapseCls);
    this.toggleLink.classList.add(...this.expandCls);
    const expand = this.expand.bind(this);
    this.toggleLink.addEventListener("click", expand);
  }

  expand() {
    this.truncate(false);
    const iconElement = document.createElement("i");
    iconElement.className = "bi bi-caret-up ps-1";
    this.toggleLink.text = this.collapseTextValue;
    this.toggleLink.appendChild(iconElement);
    this.toggleLink.classList.remove(...this.expandCls);
    this.toggleLink.classList.add(...this.collapseCls);
    const collapse = this.collapse.bind(this);
    this.toggleLink.addEventListener("click", collapse);
  }
}
